import { type UseQueryResult, useQuery } from 'react-query';
import { GrantAcceptanceTemplateService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetGrantAcceptanceTemplateOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const grantAcceptanceTemplateOptions = useQuery(
    ['getGrantAcceptanceTemplateOptions'],
    async () => {
      return await handleRequest(
        GrantAcceptanceTemplateService.getApiAwardApiAppGrantAcceptanceTemplateDropdown()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return grantAcceptanceTemplateOptions;
};

export default useGetGrantAcceptanceTemplateOptions;
